module.exports = __webpack_public_path__ + "img/diehl.4a52f087.png";